module.exports = __webpack_public_path__ + "img/wps.67ba581e.png";